import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const fetchProductCategories = async () => {
  const response = await axios.get(`${API_URL}/categories-produit`);
  return response.data?.data ?? response.data;
};

export const createProductCategory = async (payload) => {
  const response = await axios.post(`${API_URL}/categories-produit`, payload);
  return response.data;
};

export const updateProductCategory = async (id, payload) => {
  const response = await axios.put(`${API_URL}/categories-produit/${id}`, payload);
  return response.data;
};

export const deleteProductCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/categories-produit/${id}`);
  return response.data;
};
